import { useQuery } from "@tanstack/react-query";
import { queryClient } from "shared/api/queryClient";
import { getMetadataTagDetails } from "../api/getMetadataTagDetails";

const QUERY_KEY = "metadata-tag-details";

export const useMetadataTagDetailsQuery = (metadataTagId: string) => {
  return useQuery({
    queryKey: [QUERY_KEY, metadataTagId],
    queryFn: async () => {
      return await getMetadataTagDetails(metadataTagId);
    },
    enabled: !!metadataTagId,
    staleTime: 0,
  });
};

export const invalidateMetadataTagDetailsQuery = (metadataTagId: string) => {
  return queryClient.invalidateQueries({ queryKey: [QUERY_KEY, metadataTagId] });
};
